import { signal } from 'services/SignalsService'
import { spinSettings } from 'settings/custom/reels'
import { delay } from 'utils/Delay'

function check(id) {
  return spinSettings.chance && game.models.SpinModel.get().chance[id]
}

async function animate(id) {
  signal.dispatch('SCATTER:START', id)
  signal.dispatch(`SCATTER:START-${id}`)
  await delay(spinSettings.chance.time)
  signal.dispatch('SCATTER:STOP', id)
  signal.dispatch(`SCATTER:STOP-${id}`)
}

async function play(id) {
  return check(id)
    ? await animate(id)
    : void 0
}

export const ChanceManager = {
  check,
  play,
}
